import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "truncate",
  standalone: true,
})
export class TruncatePipe implements PipeTransform {
  transform(value: string | number, limit: number): string {
    if (value == null) return "";
    const strValue = value.toString();
    return strValue.length > limit
      ? strValue.substring(0, limit).trim() + "..."
      : strValue;
  }
}
